<div class="container-fluid glb-popup">
  <h2> {{formTitle}}</h2>
  <p-toast [style]="{marginTop: '80px'}">
  </p-toast>
  <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

  <button mat-icon-button [mat-dialog-close]="true" style="float:right;top:-50px;background-color: transparent;">
    <i class="pi pi-times" aria-hidden="true"></i>
  </button>
  <div>
    <div><a href="https://s3.us-east-1.amazonaws.com/img.kbmblog.com/import_contact_sample.xlsx" target="_blank">
    Sample File</a> </div>
    <p>
      Upload excel
    </p>

    <input type="file" (change)="onFileChange($event)" />

    <div id="output"></div>
    <br>
      <!--<div *ngIf="willDownload">
      <a id="download"> Download JSON File </a>
    </div>-->
  </div>

  <hr>
    <div [formGroup]="form1" class="forms w-100 d-block">
      <div class="row m-0">

        <div class="col-lg-12">
          @if (formAlert) {
            <div class="w-100 mb-3">
              <div class="w-100"
                style="text-align: center; background-color: yellow;padding:5px;margin-bottom:15px;">
                <p><b>{{formAlert}}</b></p>
              </div>
            </div>
          }
        </div>

        <div class="col-lg-12">
          <span class="p-float-label required-field w-100 mb-3">
            <p-chips class="mailinput" [addOnTab]="true" [addOnBlur]="true" (keydown)="onKeyDown($event)" formControlName="importMails" id="importMails" [allowDuplicate]="false"
              (onAdd)="validateEmailAddress($event, this.form1.value.importMails);"
            style="min-width: 500px"></p-chips>
            <label for="importMails">Paste Emails:</label>
          </span>
        </div>


        <div class="col-lg-12">
          <app-tag-join-select
            [tagSource]="80" [tagSourceId]="0" tagType="4" [viewOnly]="true" (tagsSelectedEvent)="updateTagSelected($event)">
          </app-tag-join-select>
        </div>


      </div>
    </div>
    <hr>
      <div class="row m-0">
        <div class="col-lg-12">
          <div class="btn-group">

            <div class="button-group">
              <button pButton class="btn-cancel p-button-text" [mat-dialog-close]="true">Cancel</button>
              <button pButton class="btn-addt p-button" (click)="formAdd()">Add</button>

            </div>
          </div>
        </div>
      </div>
    </div>
